import { render, staticRenderFns } from "./action_buttons_setting.vue?vue&type=template&id=b86b4702&scoped=true&"
import script from "./action_buttons_setting.vue?vue&type=script&lang=js&"
export * from "./action_buttons_setting.vue?vue&type=script&lang=js&"
import style0 from "./action_buttons_setting.vue?vue&type=style&index=0&id=b86b4702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b4702",
  null
  
)

export default component.exports